export function addHighlight(element) {
    element.setAttribute('data-highlighted', '');
}
export function removeHighlight(element) {
    element.removeAttribute('data-highlighted');
}
